// Karuzele na scroll-snap: [data-slider] (tor), [data-slider-prev|next="id"], [data-slider-dots="id"]
// Slajdy: dzieci toru z [data-slide] (np. gdy tor zawiera separatory), a bez nich — wszystkie dzieci.
function slides(track) {
    const marked = track.querySelectorAll(':scope > [data-slide]');

    return marked.length ? Array.from(marked) : Array.from(track.children);
}

function offset(track, slide) {
    return slide.offsetLeft - slides(track)[0].offsetLeft;
}

function currentIndex(track) {
    const items = slides(track);
    let index = 0,
        distance = Infinity;

    // przewinięte do końca — ostatni slajd bywa niedosuwalny do lewej krawędzi
    if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 1) {
        return items.length - 1;
    }

    items.forEach((slide, i) => {
        const current = Math.abs(offset(track, slide) - track.scrollLeft);
        if (current < distance) {
            distance = current;
            index = i;
        }
    });

    return index;
}

function scrollToIndex(track, index) {
    const items = slides(track),
        target = items[Math.max(0, Math.min(items.length - 1, index))];

    track.scrollTo({left: offset(track, target), behavior: 'smooth'});
}

function update(track, buttons, dots) {
    const maxScroll = track.scrollWidth - track.clientWidth - 1,
        index = currentIndex(track);

    buttons.prev.forEach((button) => {
        button.disabled = track.scrollLeft <= 0;
    });
    buttons.next.forEach((button) => {
        button.disabled = track.scrollLeft >= maxScroll;
    });

    dots.forEach((dotsElement) => {
        Array.from(dotsElement.children).forEach((dot, dotIndex) => {
            dot.classList.toggle('is-active', dotIndex === index);
        });
    });
}

function renderDots(track, dotsElement) {
    const count = slides(track).length;

    dotsElement.innerHTML = '';

    if (count < 2) {
        return;
    }

    for (let i = 0; i < count; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'track-dots__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Slajd ' + (i + 1));
        dot.addEventListener('click', () => scrollToIndex(track, i));
        dotsElement.appendChild(dot);
    }
}

function init() {
    document.querySelectorAll('[data-slider]').forEach((track) => {
        const id = track.id,
            buttons = {
                prev: document.querySelectorAll('[data-slider-prev="' + id + '"]'),
                next: document.querySelectorAll('[data-slider-next="' + id + '"]')
            },
            dots = document.querySelectorAll('[data-slider-dots="' + id + '"]');

        buttons.prev.forEach((button) => {
            button.addEventListener('click', () => scrollToIndex(track, currentIndex(track) - 1));
        });
        buttons.next.forEach((button) => {
            button.addEventListener('click', () => scrollToIndex(track, currentIndex(track) + 1));
        });

        dots.forEach((dotsElement) => renderDots(track, dotsElement));

        let timer;
        track.addEventListener('scroll', () => {
            window.clearTimeout(timer);
            timer = window.setTimeout(() => update(track, buttons, dots), 60);
        }, {passive: true});

        window.addEventListener('resize', () => update(track, buttons, dots));

        update(track, buttons, dots);
    });
}

export default {init};
